import BaseModel from '../base';

import constants from './constants';
import glossary from './glossary';

export default class Question extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(question, url) {
    super(question, url);
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
